import type { WebOrderRow } from "../../../api/types";
import { orderLabel } from "./webOrdersText";

/** G-143 (OD-218) — the order number opens the order in Shopify admin, in a new tab. */
export function OrderNumberLink({ row }: { row: Pick<WebOrderRow, "id" | "orderNumber" | "adminUrl"> }) {
  const label = orderLabel(row);
  if (!row.adminUrl) return <strong>{label}</strong>;
  return (
    <a href={row.adminUrl} target="_blank" rel="noopener noreferrer" title={`Open ${label} in Shopify admin`}>
      {label}
      <svg className="wo-external" width="11" height="11" viewBox="0 0 12 12" aria-hidden="true">
        <path d="M4 2h6v6M10 2L3 9" stroke="currentColor" strokeWidth="1.6" fill="none" strokeLinecap="round" />
      </svg>
    </a>
  );
}
